import React from "react";

const format = (v) => {
  if (v === "" || v === null || v === undefined) return "";
  const num = Number(String(v).replace(/[^0-9.]/g, ""));
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("en-GB");
};

export const MoneyInput = ({ id, label, hint, value, onChange, testid }) => {
  const handle = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    onChange(raw === "" ? "" : Number(raw));
  };
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-bold">
        {label}
      </label>
      {hint && <span className="text-xs text-muted-foreground -mt-1">{hint}</span>}
      <div className="relative">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 font-mono font-bold text-foreground/70 pointer-events-none">
          £
        </span>
        <input
          id={id}
          data-testid={testid}
          inputMode="numeric"
          value={format(value)}
          onChange={handle}
          placeholder="0"
          className="w-full h-12 pl-8 pr-4 rounded-xl border-2 border-foreground bg-white font-mono font-bold text-lg brutal-shadow-sm outline-none focus:translate-x-[2px] focus:translate-y-[2px] focus:shadow-[2px_2px_0px_#1e2b24] transition-[transform,box-shadow] duration-150"
        />
      </div>
    </div>
  );
};
